module.exports = __webpack_public_path__ + "img/super_wild_win_both.48511259.png";